(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-main-media]').forEach(gallery => {
      if (gallery.dataset.ressalinaMediaReady) return;
      gallery.dataset.ressalinaMediaReady = 'true';
      function loadSelectedImage() {
        gallery.querySelectorAll('.is-selected .ressalina-deferred-media-image').forEach(image => {
          image.addEventListener('load', () => image.classList.add('lazyloadt4sed'), { once: true });
          image.sizes = image.dataset.sizes;
          image.srcset = image.dataset.srcset;
          image.src = image.dataset.src;
          image.classList.remove('ressalina-deferred-media-image');
        });
      }
      const observer = new MutationObserver(loadSelectedImage);
      observer.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
      loadSelectedImage();
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(gallery)) observer.disconnect();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
